import { ChangeDetectorRef, Component, forwardRef, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal }                                          from '@ng-bootstrap/ng-bootstrap';

import { AssemblyPaymentsService }      from './assembly-payments.service';
import { AssemblyPaymentTerminalModel } from './models/assembly-payment.terminal';

@Component({
  selector   : 'wor-assembly-payments-pair',
  template: require('./assembly-payments.pair.component.html')
})
export class AssemblyPaymentsPairComponent implements OnDestroy, OnInit {
  @Input() terminal: AssemblyPaymentTerminalModel;

  currentTerminal  : AssemblyPaymentTerminalModel;
  message          = '';
  pairingSuccessful = false;
  showConfirmCode  = false;

  private handleDeviceAddressChanged  = ( e : CustomEvent ) => this._onDeviceAddressChanged(e);
  private handlePairingFlowStateChanged = ( e : CustomEvent ) => this._onPairingFlowStateChanged(e);
  private handleSecretsChanged        = ( e : CustomEvent ) => this._onSecretsChanged(e);
  private handleStatusChanged         = ( e : CustomEvent ) => this._onStatusChanged(e);

  constructor (
    public  activeModal           : NgbActiveModal,
    @Inject(forwardRef(() => AssemblyPaymentsService)) private assemblyPaymentsService: AssemblyPaymentsService,
    private changeDetectorRef     : ChangeDetectorRef
  ) {}

  ngOnInit () : void {
    this.currentTerminal = this.assemblyPaymentsService.getTerminal();

    if (this.currentTerminal) {
      this.terminal.secrets = {
        EncKey : this.terminal.ap_terminal_key,
        HmacKey: this.terminal.ap_hmac_key
      };
    }

    if (!this.assemblyPaymentsService.spiApi) {


      this.assemblyPaymentsService.initializeSpi(this.terminal);


    }

    document.addEventListener('DeviceAddressChanged',   this.handleDeviceAddressChanged);
    document.addEventListener('PairingFlowStateChanged', this.handlePairingFlowStateChanged);
    document.addEventListener('SecretsChanged',         this.handleSecretsChanged);
    document.addEventListener('StatusChanged',          this.handleStatusChanged);

    this.assemblyPaymentsService.spiApi.Pair();
  }

  ngOnDestroy () : void {


    document.removeEventListener('DeviceAddressChanged',   this.handleDeviceAddressChanged);
    document.removeEventListener('PairingFlowStateChanged', this.handlePairingFlowStateChanged);
    document.removeEventListener('SecretsChanged',         this.handleSecretsChanged);
    document.removeEventListener('StatusChanged',          this.handleStatusChanged);


  }

  cancel () : void {


    this.assemblyPaymentsService.spiApi.PairingCancel();


    this.activeModal.close();


  }

  pairCodeCorrect () : void {


    this.assemblyPaymentsService.spiApi.PairingConfirmCode();


  }

  pairCodeIncorrect () : void {


    this.assemblyPaymentsService.spiApi.PairingCancel();


  }

  private _onDeviceAddressChanged ( e : CustomEvent ) : void {


    this.assemblyPaymentsService.spiApi._eftposAddress = e.detail.Address;


  }

  private _onPairingFlowStateChanged ( e : CustomEvent ) : void {
    this.message = e.detail.Message;

    if (e.detail.ConfirmationCode && e.detail.AwaitingCheckFromPos) {


      this.message = `${ e.detail.Message }\n\n${ e.detail.ConfirmationCode }`;


    }

    this.showConfirmCode = e.detail.AwaitingCheckFromPos;

    if (e.detail.Successful && e.detail.Finished) {


      this.pairingSuccessful = true;
      this.showConfirmCode   = false;

      this.assemblyPaymentsService.spiApi.AckFlowEndedAndBackToIdle();


    }

    this.changeDetectorRef.detectChanges();
  }

  private _onSecretsChanged ( e : CustomEvent ) : void {
    this.currentTerminal = this.assemblyPaymentsService.getTerminal();

    if (e.detail) {
      if (e.detail.EncKey && this.currentTerminal) {

        this.currentTerminal = Object.assign(this.terminal, this.currentTerminal);

        this.currentTerminal.alternate_ip_address = this.assemblyPaymentsService.spiApi._eftposAddress;
        this.currentTerminal.secrets              = e.detail;

      }
      else if (e.detail.EncKey && !this.currentTerminal) {
        this.currentTerminal = this.terminal;

        this.currentTerminal.alternate_ip_address = this.assemblyPaymentsService.spiApi._eftposAddress;
        this.currentTerminal.status               = '';
        this.currentTerminal.secrets              = e.detail;
      }

      this.assemblyPaymentsService.storeTerminal(this.currentTerminal);
    }
  }

  private _onStatusChanged ( e : CustomEvent ) : void {
    this.currentTerminal = this.assemblyPaymentsService.getTerminal();

    if (this.currentTerminal) {
      if (this.currentTerminal.status !== e.detail) {

        this.currentTerminal.status = e.detail;

        this.assemblyPaymentsService.storeTerminal(this.currentTerminal);

      }
    }
    else {
      this.currentTerminal = this.terminal;

      this.currentTerminal.alternate_ip_address = this.assemblyPaymentsService.spiApi._eftposAddress;
      this.currentTerminal.status               = e.detail;
    }

    this.assemblyPaymentsService.storeTerminal(this.currentTerminal);

    this.changeDetectorRef.detectChanges();
  }
}
